import React, { Component } from "react";
import { Link } from "react-router-dom";

class SubNavStickers extends Component {
  render() {
    return (
      <div className="subnav">
        <ul align="center">
          <li className="subnav-item">
            <Link to="/layoutdesign/jessa18">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1540407248/rtds_work/Invitations/Jessa18thInvi-Mockup.jpg"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/layoutdesign/omg">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1540401409/rtds_work/Logo/OMGLogoMockup.jpg"
                alt="client-app"
              />
            </Link>
          </li>
          <li className="subnav-item">
            <Link to="/layoutdesign/mck">
              <img
                className="image"
                src="https://res.cloudinary.com/doddfudab/image/upload/v1540400341/rtds_work/Logo/MCKLogo_Mockup.jpg"
                alt="client-app"
              />
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default SubNavStickers;



// WEBPACK FOOTER //
// ./src/components/pages/category/SubNavLayoutDesign.js